

const imagesArray = [
  require("../assets/sprites-real-estate/Diorama.0001-nosprite.png"),
  require("../assets/sprites-real-estate/Diorama.0001-nosprite.png"),
  require("../assets/sprites-real-estate/Diorama.0001-nosprite.png"),
  require("../assets/sprites-real-estate/Diorama.0001-nosprite.png"),
  require("../assets/sprites-real-estate/Diorama.0001-nosprite.png"),
  require("../assets/sprites-real-estate/Diorama.0001-nosprite.png"),
  require("../assets/sprites-real-estate/Diorama.0001-nosprite.png")
  
]

export {
  imagesArray
};